export interface JobVacancy {
  id: string;
  title: string;
  language: 'nl' | 'fr';
  location: string;
  level: 'junior' | 'senior';
  description: string;
  phases?: {
    phase1: {
      title: string;
      description: string;
      tasks: string[];
    };
    phase2: {
      title: string;
      description: string;
      tasks: string[];
    };
  };
  responsibilities: string[];
  workLocation: string;
  requirements: {
    mustHaves: string[];
    niceToHaves: string[];
  };
  benefits: string[];
  applicationEmail: {
    subject: string;
    body: string;
  };
}

export const jobVacancies: JobVacancy[] = [
  {
    id: 'sales-development-medewerker-aalst',
    title: 'Sales Development Medewerker',
    language: 'nl',
    location: 'Aalst',
    level: 'junior',
    description: 'Word onderdeel van ons dynamische sales team',
    phases: {
      phase1: {
        title: 'Jouw start (eerste maanden, ± 90% van je taken)',
        description: 'Telefonische prospectie',
        tasks: [
          'Informatie verzamelen bij potentiële klanten',
          'Onze klanten en hun diensten/producten professioneel voorstellen',
          'Gesprekken nauwkeurig opvolgen via digitale tools',
          'Resultaten rapporteren aan je verantwoordelijke via ons online intranet'
        ]
      },
      phase2: {
        title: 'Uitbreiding van je takenpakket',
        description: 'Na verloop van tijd groei je door en neem je extra verantwoordelijkheden op',
        tasks: [
          'Inside Sales: Sales targets behalen en klanttevredenheid verhogen',
          'Proactief meedenken met onze klanten en hen de beste service bieden',
          'Samen met je team streven naar een optimale bereikbaarheid',
          'Administratie & opvolging: Bestelbonnen opmaken en opvolgen',
          'Agendabeheer en infomails versturen',
          'Up-to-date houden van klantgegevens in ons CRM-systeem'
        ]
      }
    },
    responsibilities: [
      'Telefonisch contact opnemen met bedrijven om opportuniteiten te detecteren',
      'Afspraken inplannen voor onze klanten',
      'Leads grondig kwalificeren',
      'Het eerste aanspreekpunt zijn in het salesproces'
    ],
    workLocation: 'Je werkt vanuit ons kantoor in Aalst, maar afhankelijk van de klantprojecten kan je ook op locatie bij de klant werken en is telewerk mogelijk.',
    requirements: {
      mustHaves: [
        'Je werkt graag in een open kantoorruimte',
        'Je hebt oog voor detail en volgt dossiers nauwkeurig op',
        'Je beheerst de Nederlandse taal perfect, zowel gesproken als geschreven'
      ],
      niceToHaves: [
        'Ervaring in B2B cold calling of sales/customer service',
        'Kennis van Frans, Engels of andere talen',
        'Rijbewijs B'
      ]
    },
    benefits: [
      'Een afwisselende job in een toffe en collegiale werkomgeving',
      '38-uren werkweek met een aantrekkelijk rooster',
      'Onmiddellijk een vast contract',
      'Maaltijdcheques en hospitalisatieverzekering',
      'Teamincentives bij het behalen van targets',
      'Werk-privébalans die perfect te combineren is met je gezin'
    ],
    applicationEmail: {
      subject: 'Sollicitatie Sales Development Medewerker',
      body: 'Beste Raisa,%0D%0A%0D%0AIk ben geïnteresseerd in de vacature voor Sales Development Medewerker bij De Afsprakenmaker.%0D%0A%0D%0AIn bijlage vindt u mijn CV en een korte motivatie.%0D%0A%0D%0AMet vriendelijke groeten,%0D%0A[Uw naam]'
    }
  },
  {
    id: 'senior-sales-executive-aalst',
    title: 'Senior Sales Executive',
    language: 'nl',
    location: 'Aalst',
    level: 'senior',
    description: 'Ervaren sales professional voor uitdagende B2B projecten',
    phases: {
      phase1: {
        title: 'Jouw start (eerste maanden, ± 90% van je taken)',
        description: 'Telefonische prospectie',
        tasks: [
          'Informatie verzamelen bij potentiële klanten',
          'Onze klanten en hun diensten/producten professioneel voorstellen',
          'Gesprekken nauwkeurig opvolgen via digitale tools',
          'Resultaten rapporteren aan je verantwoordelijke via ons online intranet'
        ]
      },
      phase2: {
        title: 'Uitbreiding van je takenpakket',
        description: 'Na verloop van tijd groei je door en neem je extra verantwoordelijkheden op',
        tasks: [
          'Inside Sales: Sales targets behalen en klanttevredenheid verhogen',
          'Proactief meedenken met onze klanten en hen de beste service bieden',
          'Samen met je team streven naar een optimale bereikbaarheid',
          'Administratie & opvolging: Bestelbonnen opmaken en opvolgen',
          'Agendabeheer en infomails versturen',
          'Up-to-date houden van klantgegevens in ons CRM-systeem'
        ]
      }
    },
    responsibilities: [
      'Actieve prospectie & sales development',
      'Complexe B2B verkoopcycli beheren',
      'Strategische klantrelaties opbouwen',
      'Commerciële doelstellingen overtreffen'
    ],
    workLocation: 'Je werkt vanuit ons kantoor in Aalst, maar afhankelijk van de klantprojecten kan je ook op locatie bij de klant werken en is telewerk mogelijk.',
    requirements: {
      mustHaves: [
        'Je werkt graag in een open kantoorruimte',
        'Je hebt oog voor detail en volgt dossiers nauwkeurig op',
        'Je beheerst de Nederlandse taal perfect, zowel gesproken als geschreven'
      ],
      niceToHaves: [
        'Ervaring in B2B cold calling of sales/customer service',
        'Kennis van Frans, Engels of andere talen',
        'Rijbewijs B'
      ]
    },
    benefits: [
      'Een afwisselende job in een toffe en collegiale werkomgeving',
      '38-uren werkweek met een aantrekkelijk rooster',
      'Onmiddellijk een vast contract',
      'Maaltijdcheques en hospitalisatieverzekering',
      'Teamincentives bij het behalen van targets',
      'Werk-privébalans die perfect te combineren is met je gezin'
    ],
    applicationEmail: {
      subject: 'Sollicitatie Senior Sales Executive',
      body: 'Beste Raisa,%0D%0A%0D%0AIk ben geïnteresseerd in de vacature voor Senior Sales Executive bij De Afsprakenmaker.%0D%0A%0D%0AIn bijlage vindt u mijn CV en een korte motivatie.%0D%0A%0D%0AMet vriendelijke groeten,%0D%0A[Uw naam]'
    }
  },
  {
    id: 'consultant-ventes-sortantes-aalst',
    title: 'Consultant en Ventes Sortantes',
    language: 'fr',
    location: 'Aalst',
    level: 'junior',
    description: 'Rejoignez notre équipe commerciale dynamique',
    phases: {
      phase1: {
        title: 'Votre Départ (premiers mois, ± 90% de vos tâches)',
        description: 'Prospection téléphonique',
        tasks: [
          'Collecter des informations auprès des prospects',
          'Présenter nos clients et leurs services/produits de manière professionnelle',
          'Assurer le suivi des appels via des outils digitaux',
          'Rapporter les résultats à votre responsable via notre intranet en ligne'
        ]
      },
      phase2: {
        title: 'Élargissement de Vos Responsabilités',
        description: 'Avec le temps, vous développerez d\'autres responsabilités',
        tasks: [
          'Ventes internes: Atteindre les objectifs de vente et améliorer la satisfaction des clients',
          'Anticiper les besoins des clients et leur fournir un excellent service',
          'Travailler en équipe pour garantir une disponibilité optimale',
          'Administration & Suivi: Rédiger et suivre les bons de commande',
          'Gérer les agendas et envoyer des e-mails d\'information',
          'Maintenir les données clients à jour dans notre CRM'
        ]
      }
    },
    responsibilities: [
      'Prospection téléphonique active',
      'Présentation professionnelle des services clients',
      'Qualification des prospects',
      'Suivi et rapportage des résultats'
    ],
    workLocation: 'Vous travaillerez depuis notre bureau à Aalst, mais selon les projets, vous pourrez également travailler chez le client et en télétravail.',
    requirements: {
      mustHaves: [
        'Vous aimez travailler dans un open space',
        'Vous êtes organisé(e) et rigoureux(se) dans le suivi des dossiers',
        'Vous maîtrisez parfaitement le néerlandais, à l\'oral et à l\'écrit'
      ],
      niceToHaves: [
        'Expérience en prospection B2B ou en service client/vente',
        'Connaissance du français, anglais ou autres langues',
        'Permis de conduire (B)'
      ]
    },
    benefits: [
      'Un poste varié dans un environnement convivial et collaboratif',
      '38 heures/semaine avec un horaire attractif',
      'Contrat à durée indéterminée dès le premier jour',
      'Chèques-repas & assurance hospitalisation',
      'Incentives d\'équipe en fonction des résultats',
      'Un bon équilibre travail-vie privée, idéal pour concilier avec la famille'
    ],
    applicationEmail: {
      subject: 'Candidature Consultant en Ventes Sortantes',
      body: 'Chère Raisa,%0D%0A%0D%0AJe suis intéressé(e) par le poste de Consultant en Ventes Sortantes chez De Afsprakenmaker.%0D%0A%0D%0AVeuillez trouver en pièce jointe mon CV et une lettre de motivation.%0D%0A%0D%0ACordialement,%0D%0A[Votre nom]'
    }
  }
];
